module.exports = __webpack_public_path__ + "img/4.c26da616.png";